import Component from "@glimmer/component"

export interface Sig {
  Args: {
    model: {
      attachmentTitle: string
      attachmentId: string
      attachmentUrl: string
    }
    closeModal: () => {}
  }
}

export default class AttachmentPreviewModal extends Component<Sig> {
  get isFilepickerUrl() {
    let url = this.args.model.attachmentUrl
    return url.match("filepicker") !== null || url.match("filestack") !== null
  }
}

declare module "@glint/environment-ember-loose/registry" {
  export default interface Registry {
    AttachmentPreviewModal: typeof AttachmentPreviewModal
  }
}
